import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { initSentry } from '@volee/telemetry'
import { Toaster } from '@volee/ui'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { QueryDevtools } from './components/devtools.tsx'
import { createAppRouter } from './router.tsx'
import { auth } from './services/auth.ts'
import { createQueryClient } from './services/query.ts'
import { handOverNativeSplash } from './services/splash-screen.ts'

import './styles.css'

// Sentry first, so an error anywhere in the rest of the boot is already captured.
initSentry()

const queryClient = createQueryClient()
const router = createAppRouter(queryClient)

const rootElement = document.getElementById('root')
if (rootElement === null) {
  throw new Error('Missing #root in index.html')
}

// Not awaited: the boot screen stands on its own while the session is restored.
void handOverNativeSplash()

// Awaited before rendering, and the catch swallows the normal case:
// apps/frontend/docs/boot-e-le-due-righe.md says what each half costs if it goes.
await auth.restore().catch(() => false)

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster clearBottomBar />
      <QueryDevtools />
    </QueryClientProvider>
  </StrictMode>,
)
